export default __webpack_public_path__ + "static/media/cognetic-logo.e41e6e04.png";